import { createAsyncThunk } from "@reduxjs/toolkit";
import { dataBaseInstance } from "../../services/api.js";

export const getDatabaseTree = createAsyncThunk(
  "database/getDatabaseTree",
  async (_, thunkAPI) => {
    try {
      const response = await dataBaseInstance.get("/api/catalog/tree");

      console.log("getDatabaseTree", response.data);

      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 404) {
        return thunkAPI.rejectWithValue({
          status: 404,
          message: "Not found",
        });
      }
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);
